import type { TypePolicies } from '@apollo/client';

export const Agent: TypePolicies['Agent'] = {
  keyFields: ['id', 'teamId'],
};
